import { render, staticRenderFns } from "./nianLingFenXi.vue?vue&type=template&id=2ec09ac6&scoped=true&"
import script from "./nianLingFenXi.vue?vue&type=script&lang=js&"
export * from "./nianLingFenXi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec09ac6",
  null
  
)

export default component.exports